import { memo } from 'react';

import styles from '@/components/organisms/Tile/TileBusinessHours.module.scss';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

type Props = { className?: string; noMargin?: boolean };
function TileSkeleton({ className = '', noMargin = true }: Props) {
  return (
    <div
      className={cn(className, { tile: true, tile__preview: true, 'tile--mr0': noMargin })}
      data-testid="tile-skeleton"
    >
      <div className={styles.wrapper}>
        <div className={styles.dnd}>
          <Skeleton className="h-5 w-[18px]" />
        </div>
        <div className={styles.info}>
          <span className={styles.name}>
            <Skeleton className="h-6 w-[200px]" />
            <Skeleton className="h-6 w-[200px]" />
          </span>
          <div className={styles.menu}>
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(TileSkeleton);
